import React, { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PageBreadcrumb } from '../../components/library/page-breadcrumb/PageBreadcrumb';

import { Toolbar, Item as ToolbarItem } from 'devextreme-react/toolbar';
import DropDownButton, { Item as DropDownItem } from 'devextreme-react/drop-down-button';
import TabPanel, { Item as TabPanelItem } from 'devextreme-react/tab-panel';
import ValidationGroup from 'devextreme-react/validation-group';
import Button from 'devextreme-react/button';
import ScrollView from 'devextreme-react/scroll-view';

import { TaskForm, CardActivities, CardNotes, CardMessages } from '../../components';

import { Task } from '../../types/task';

import { getTask } from '../../data/template-data';

import './planning-task-details.scss';

const DEFAULT_TASK_ID = 1;

export const PlanningTaskDetails = () => {
  const [searchParams] = useSearchParams();
  const id = parseInt(searchParams.get('id') || '', 10);
  const taskId = id || DEFAULT_TASK_ID;
  const [task, setTask] = useState<Task>();
  const [isLoading, setIsLoading] = useState(false);

  const loadData = useCallback(() => {
    getTask(taskId)
      .then((data) => {
        setTask(data);
        setIsLoading(false);
      })
      .catch((error) => console.log(error));
  }, [taskId]);

  const refresh = useCallback(() => {
    setIsLoading(true);
    loadData();
  }, [loadData]);

  useEffect(() => {
    loadData();
  }, []);

  return (
    <ScrollView className='view-wrapper-scroll'>
      <div className='view-wrapper view-wrapper-details'>
        <div className='task-details-header'>
          <PageBreadcrumb title={task?.text ?? 'Chi tiết công việc'} parents={[{ label: 'Danh sách công việc', path: '/planning-task-list?view=list' }]} />
          <Toolbar className='toolbar-details task-details-actions'>
            <ToolbarItem location='before' locateInMenu='auto'>
              <DropDownButton text='Actions' stylingMode='text' dropDownOptions={{ width: 'auto' }}>
                <DropDownItem text='Duplicate' />
                <DropDownItem text='Close' />
                <DropDownItem text='Delete' />
              </DropDownButton>
            </ToolbarItem>
            <ToolbarItem
              location='before'
              locateInMenu='auto'
              widget='dxButton'
              showText='inMenu'
            >
              <Button
                text='Attach'
                icon='attach'
                stylingMode='text'
              />
            </ToolbarItem>
            <ToolbarItem
              location='before'
              locateInMenu='auto'
              widget='dxButton'
              showText='inMenu'
            >
              <Button
                text='Refresh'
                icon='refresh'
                stylingMode='text'
                onClick={refresh}
              />
            </ToolbarItem>
          </Toolbar>
        </div>
        <div className='panels'>
          <div className='left'>
            <ValidationGroup>
              <TaskForm task={task} isLoading={isLoading} />
            </ValidationGroup>
          </div>
          <div className='right'>
            <div className='dx-card details-card'>
              <TabPanel
                showNavButtons
                focusStateEnabled={false}
                deferRendering={false}
              >
                <TabPanelItem title='Activities'>
                  <CardActivities activities={task?.activities} isLoading={isLoading} />
                </TabPanelItem>
                <TabPanelItem title='Notes'>
                  <CardNotes items={task?.notes} user={task?.owner} />
                </TabPanelItem>
                <TabPanelItem title='Messages'>
                  <CardMessages items={task?.messages} user={task?.owner} />
                </TabPanelItem>
              </TabPanel>
            </div>
          </div>
        </div>
      </div>
    </ScrollView>
  );
};
